import { useEffect, useRef, useState, useLayoutEffect } from 'react';
import style from './CardFlipante.module.css';

const CardFlipante = ({ 
    frente, 
    verso, 
    terceiroLado, 
    lado = 0,    
    getTamanhoCard = false, 
    style_frente = "", 
    style_verso = "", 
    style_terceiro = "" 
}) => {
    const cardRef = useRef(null);
    const frenteRef = useRef(null);
    const versoRef = useRef(null);
    const terceiroRef = useRef(null); 

    // Estados para controlar a renderização de cada lado
    const [mostrarFrente, setMostrarFrente] = useState(lado === 0);
    const [mostrarVerso, setMostrarVerso] = useState(lado === 1);
    const [mostrarTerceiro, setMostrarTerceiro] = useState(lado === 2);

    useEffect(() => {
        const card = cardRef.current;
        if (card) {
            // 1. Mostra o novo conteúdo para que ele exista no DOM antes da animação
            if (lado === 0) setMostrarFrente(true);
            if (lado === 1) setMostrarVerso(true);
            if (lado === 2) setMostrarTerceiro(true);
            
            // Pequeno delay para garantir que o React renderizou o novo lado
            setTimeout(() => {
                // 2. Aplica ou remove a classe de flip.
                // Lado 1 (verso) é o único "flipado". Lados 0 e 2 ficam na posição original.
                if (lado === 1) {
                    card.classList.add(style.flipped);
                } else {
                    card.classList.remove(style.flipped);
                }
            }, 50); // Delay mínimo

            // 3. Esconde o conteúdo antigo após a animação de flip terminar
            setTimeout(() => {
                if (lado !== 0) setMostrarFrente(false);
                if (lado !== 1) setMostrarVerso(false);
                if (lado !== 2) setMostrarTerceiro(false);
            }, 400); // Duração da sua animação
        }
    }, [lado]); // O efeito agora depende da prop 'lado'

    useLayoutEffect(() => {
        const enviarTamanho = async () => {
            if (!getTamanhoCard) return;

            let elementoAtivo = null;
            if (mostrarFrente) elementoAtivo = frenteRef.current;
            else if (mostrarVerso) elementoAtivo = versoRef.current;
            else if (mostrarTerceiro) elementoAtivo = terceiroRef.current;

            if (elementoAtivo) {
                // Usamos um timeout para esperar a animação de fade-in e o flip
                await setTimeout(() => {
                    getTamanhoCard({ width: elementoAtivo.offsetWidth, height: elementoAtivo.offsetHeight });
                }, 400);
            }
        };

        enviarTamanho();
    }, [mostrarFrente, mostrarVerso, mostrarTerceiro, getTamanhoCard, lado]);

    return (
        <div className={`${style.card_flipante} ${style.fade_in}`} ref={cardRef}>
            {
                mostrarFrente &&
                <div className={`${style_frente} ${style.frente}`} ref={frenteRef}>
                    {frente}
                </div>
            }

            {
                mostrarVerso &&
                <div className={`${style_verso} ${style.verso}`} ref={versoRef}>
                    {verso}
                </div>
            }
            
            
            {
                mostrarTerceiro &&
                <div className={`${style_terceiro} ${style.frente}`} ref={terceiroRef}>
                    {terceiroLado}
                </div>
            }
        </div>
    );
};

export default CardFlipante;